var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38911 0.238347L7 5.84924L12.6109 0.238327C12.9287 -0.0794428 13.4439 -0.0794425 13.7617 0.238328C14.0794 0.5561 14.0794 1.07135 13.7617 1.38912L8.15079 7L13.7617 12.6109C14.0794 12.9287 14.0794 13.4439 13.7617 13.7617C13.4439 14.0794 12.9287 14.0794 12.6109 13.7617L7 8.1508L1.38911 13.7617C1.07134 14.0794 0.556117 14.0794 0.238347 13.7617C-0.0794242 13.4439 -0.0794242 12.9287 0.238347 12.6109L5.84921 7L0.238327 1.38913C-0.0794424 1.07136 -0.0794427 0.556118 0.238328 0.238347C0.556098 -0.0794239 1.07134 -0.0794239 1.38911 0.238347Z",
    fill: "#A7B2AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close-grey.00174b93fc0557b4886522bd1cde59d9.svg";
export { ForwardRef as ReactComponent };